import { render, staticRenderFns } from "./YA_ChartBar.vue?vue&type=template&id=ab597100&scoped=true"
import script from "./YA_ChartBar.vue?vue&type=script&lang=js"
export * from "./YA_ChartBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab597100",
  null
  
)

export default component.exports